/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SymbolFundamentalsAvailableAttributesDto
 */
export interface SymbolFundamentalsAvailableAttributesDto {
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsAvailableAttributesDto
     */
    symbolId: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsAvailableAttributesDto
     */
    periodType: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SymbolFundamentalsAvailableAttributesDto
     */
    attributes: Array<string>;
}

export function SymbolFundamentalsAvailableAttributesDtoFromJSON(json: any): SymbolFundamentalsAvailableAttributesDto {
    return SymbolFundamentalsAvailableAttributesDtoFromJSONTyped(json, false);
}

export function SymbolFundamentalsAvailableAttributesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFundamentalsAvailableAttributesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbolId': json['symbolId'],
        'periodType': json['periodType'],
        'attributes': json['attributes'],
    };
}

export function SymbolFundamentalsAvailableAttributesDtoToJSON(value?: SymbolFundamentalsAvailableAttributesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbolId': value.symbolId,
        'periodType': value.periodType,
        'attributes': value.attributes,
    };
}

